import type { ReactNode } from "react";
import { useReducedMotion } from "motion/react";
import { TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from "@/components/animate-ui";
import { enterTransition, exitTransition } from "@/lib/motion";

export function Tooltip({ label, children, side = "top" }: { label: string; children: ReactNode; side?: "top" | "right" | "bottom" | "left" }) {
  const reduce = useReducedMotion();
  return (
    <TooltipProvider delayDuration={280}>
      <TooltipRoot>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipPortal>
          <TooltipContent
            data-slot="tooltip"
            side={side}
            sideOffset={8}
            transition={enterTransition(reduce)}
            exitTransition={exitTransition(reduce)}
            className="z-[90] max-w-xs rounded-control bg-foreground px-2.5 py-1.5 text-xs text-background shadow-floating"
          >
            {label}
          </TooltipContent>
        </TooltipPortal>
      </TooltipRoot>
    </TooltipProvider>
  );
}
